import { API_BASE } from '@/Module/Core/Constant';

export const COURSE_API = {
  GET_LIST_BY_CATEGORY_CATEGORY_ID: `${API_BASE}/Course/GetByCategoryCategoryId`,
  GET_BY_SLUG: `${API_BASE}/Course/GetCourseBySeoUrl`,
  GET_BY_SLUG_AND_CATEGORY_CATEGORY_ID: `${API_BASE}/Course/GetCourseBySeoUrlCategoryCategoryId`,
  GET_LIST: `${API_BASE}/v2/Course`,
};
